export const riskProfileDeclaration =
  'I hereby consent / I am authorized to consent that PGIM INDIA ASSET MANAGEMENT PRIVATE LIMITED can use the information provided here to derive the Risk Tolerance score of the Applicant(s)';
export const sectionFilledByInvestor = 'To be filled by investor';
export const nomineeDetailsDeclaration =
  'I / We want the details of my / our nominee to be printed in the statement of holding or statement of transactions, provided to me/ us by the DP as follows. (please tick, as appropriate)';
